/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import React, { memo } from 'react';
import { createBrowserRouter, createRoutesFromElements, Route, RouterProvider } from 'react-router';

import { HURoute } from './components/HURoute/HURoute';
import { BasicRoutes } from './constants/basicRoutes';
import { NotFoundLayout } from './layouts/NotFoundLayout/NotFoundLayout';
import { NotFoundPage } from './pages/NotFoundPage/NotFoundPage';
import { AdminSection } from './sections/AdminSection/AdminSection';
import { GeneralSection } from './sections/GeneralSection/GeneralSection';

export const Routes = memo(() => {
  const router = createBrowserRouter(
    createRoutesFromElements(
      <>
        <Route path={`${BasicRoutes.ADMIN}/*`} element={<AdminSection />} />
        <Route path={`${BasicRoutes.HOME}*`} element={<GeneralSection />} />
        <Route
          path="*"
          element={
            <HURoute>
              <NotFoundLayout>
                <NotFoundPage />
              </NotFoundLayout>
            </HURoute>
          }
        />
      </>,
    ),
  );

  return <RouterProvider router={router} />;
});
